module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-upload"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.intro)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "attachment-input"
  }, [_c('div', {
    staticClass: "title"
  }, [(_vm.$store.state.form.attachments.length === 1) ? _c('span', [_vm._v("\n                " + _vm._s(_vm.$store.state.form.attachments.length) + "\n                " + _vm._s(_vm.singleFileUploaded) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.form.attachments.length > 1) ? _c('span', [_vm._v("\n                " + _vm._s(_vm.$store.state.form.attachments.length) + "\n                " + _vm._s(_vm.multipleFilesUploaded) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('form', {
    ref: "attachmentform",
    staticClass: "attachments-form"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "name": "file",
      "id": "file",
      "multiple": "",
      "accept": "image/*,video/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    },
    on: {
      "change": _vm.uploadFile
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "file"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.addFilesButton) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "files-wrapper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "file-loader"
  }, [_c('i', {
    staticClass: "fal fa-circle-notch fa-spin"
  })]), _vm._v(" "), _vm._l((_vm.$store.state.form.attachments), function(attachment, index) {
    return _c('div', {
      key: attachment.path,
      staticClass: "file"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('div', {
      staticClass: "main"
    }, [_vm._v("\n                    " + _vm._s(attachment.name) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "size"
    }, [_vm._v("\n                    " + _vm._s(_vm._f("tomb")(attachment.size)) + "    \n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "remove",
      on: {
        "click": function($event) {
          return _vm.removeAttachment(index)
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.remove) + "\n            ")])])
  }), _vm._v(" "), (_vm.$store.state.form.attachments.length === 0) ? _c('div', {
    staticClass: "no-files"
  }, [_vm._v("\n            " + _vm._s(_vm.noFilesUploaded) + "\n        ")]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bc6810e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/file-upload.vue
// module id = 354
// module chunks = 1